import { pct } from "../lib/format.ts";

interface UsageBarProps {
  label: string;
  value: number;
  max: number;
  /** Human-readable current/max, e.g. "1.2 GB / 5 GB". */
  display: string;
}

export function UsageBar({ label, value, max, display }: UsageBarProps) {
  const percent = pct(value, max);
  const tone =
    percent >= 90 ? "danger" : percent >= 75 ? "warn" : "ok";

  return (
    <div className="usagebar">
      <div className="usagebar-head">
        <span className="usagebar-label">{label}</span>
        <span className="usagebar-value">{display}</span>
      </div>
      <div
        className="usagebar-track"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div
          className={`usagebar-fill usagebar-fill--${tone}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span className="usagebar-pct">{percent}%</span>
    </div>
  );
}
